import { ContextData } from '@taxfix/scouts-books'

import { useProfile } from '@/store/profile'

import { useSelfEmploymentProfile } from './use-self-employment-profile'

const useBookkeepingUserData = () => {
    const { profile } = useProfile()
    const selfEmploymentProfile = useSelfEmploymentProfile()

    const hasSelfEmploymentAddress = !!selfEmploymentProfile.businessAddressStreetAddress

    const businessStreetAddress = selfEmploymentProfile.businessAddressStreetAddress?.trim() || ''

    const personalAddress = profile.addressStreetAddress?.trim() || ''

    const user = {
        id: profile.id,
        name: `${profile.firstName || ''} ${profile.lastName || ''}`.trim(),
        idNumber: profile.uniqueTaxpayerReference || '',
        address: {
            street: hasSelfEmploymentAddress ? businessStreetAddress : personalAddress,
            city: hasSelfEmploymentAddress
                ? selfEmploymentProfile?.businessAddressCity || ''
                : profile.addressCity || '',
            postcode: hasSelfEmploymentAddress
                ? selfEmploymentProfile?.businessAddressPostcode || ''
                : profile?.addressPostcode || '',
        },
    }

    return { user }
}

export const useBookkeepingData = (): ContextData => {
    const { user } = useBookkeepingUserData()

    return { user }
}
